import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity2 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_2;
}

export default DirtRoadTileEntity2;
